<script>
	import gridbase from './gridbase.vue'
	const rendererList = {}
	export default {
		renderer: {
			add: (component, obj) => {
				rendererList[component] = obj
			}
		},
		extends: gridbase,
		props: {

		},
		render(h) {
			let actionSheet = []
			let params = {
				$table: this,
				$grid: this.$parent.$parent,
			}
			this.buttons.forEach((item) => {
				if (item.buttonRender && item.buttonRender.name) {
					let component = item.buttonRender.name
					if (rendererList[component]) {
						params.button = item.buttonRender
						actionSheet.push(rendererList[component].renderToolbarButton(h, item.buttonRender, params))
					}
				} else {
					if(!item.disabled){
						actionSheet.push(
							<van-button class="van-action-sheet__item" type="button" onClick={()=>{
								params.$table.toolbarButtonClickEvent(item)
							}} >{item.name}</van-button>
						)
					}
				}
				this.$slots.actionSheet = actionSheet
			})
			return gridbase.render.call(this, h)
		},
		data() {
			return {
				rendererList:rendererList
			}
		},
		created() {
			//console.log(this.buttons)


		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			hideAction() {
				this.$nextTick(() => {
					this.actionShow = false
				})
			}
		},
		components: {

		}
	}
</script>
